export default "__VITE_ASSET__DXOb3ipF__"